const getSearchParamsString = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const searchParamsString = searchParams.toString();

  return searchParamsString ? `?${searchParamsString}` : '';
};

export default getSearchParamsString;
